module.exports = __webpack_public_path__ + "static/media/tripTrail_Yay.66798701.svg";